import ActionLink, { isValidPhoneNumberText } from 'components/ActionLink';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import type {
	ActionLink as ActionLinkModel,
	Field,
	SitecoreBlockProps,
} from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

interface Item {
	action?: ActionLinkModel;
	isPrimary?: Field<boolean>;
}

interface Props extends SitecoreBlockProps {
	fields?: {
		items?: Item[];
	};
}

export default function ActionButtonDouble({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const actions = filterTruthy(
		fields.items?.map((item) => ({
			...item.action,
			isPrimary: Boolean(item.isPrimary?.value),
		})),
		'type',
		'text',
	);

	if (actions.length < 2) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="ActionButtonDouble"
				description="Requires two action buttons, both with a type and text"
			/>
		);
	}

	const phoneAction = actions.find((item) => item.type === 'Phone');
	if (phoneAction && !isValidPhoneNumberText(phoneAction.text)) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="ActionButtonDouble with Phone"
				description="Phone action text must contain a phone number of at least 5 digits"
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
			innerClassName="flex gap-r-md max-sm:flex-col"
		>
			{actions.map((action) => (
				<ActionLink
					key={action.text}
					{...action}
					buttonVariant={action.isPrimary ? 'branded' : undefined}
					className="min-w-64 max-sm:w-full"
				/>
			))}
		</LayoutContainer>
	);
}
ActionButtonDouble.displayName = 'ActionButtonDouble';
